import {PolIcon} from "components/PolIcon/policon";
import React, {useEffect} from 'react';
import {useHistory} from "react-router-dom";
import PolPopup from "v4/components/ui/PolPopup/PolPopup";
import {MAILING_SEND} from "v4/data/apiRoutes";
import {CONTACT} from "v4/data/entities";
import CampaignPopup from "v4/features/front/campaign/components/CampaignPopup/CampaignPopup";
import ListingExport from "v4/features/front/export/components/ListingExport/ListingExport";
import { useNavigation } from "v4/features/front/navigation/contexts/NavigationContext";
import SearchLinkedEntitiesList from "v4/features/front/searchLinkedEntities/components/searchLinkedEntitiesList";
import useFetch from "v4/hooks/useFetch";
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import useToggle from "v4/hooks/useToggle";
import {generateUrl} from "v4/services/api.service";
import CampaignVoter from "v4/voters/campaignVoter";

export default function ContactsListingTools({checkedRows}) {
    const {t} = usePolTranslation();
    const {replace} = useHistory();
    const {getRouteByNativeIdentifier} = useNavigation();
    const [{data, isLoading}, fetchMailing] = useFetch();
    const {canCreateCampaign} = CampaignVoter();
    const [showCampaignPopup, toggleShowCampaignPopup] = useToggle();

    const handleNoSelectedItems = (e) => (checkedRows?.length === 0) && e.stopPropagation();

    const handleMailing = () => {
        fetchMailing({
            url: generateUrl(MAILING_SEND),
            config: {
                method: 'POST',
                body: JSON.stringify({
                    type: `${CONTACT}s`, /* TODO: changer contacts en contact côté back */
                    value: checkedRows
                })
            }
        })
    }

    useEffect(() => {
        if (!data?.success) return;

        const emailingRoute = getRouteByNativeIdentifier('main_newsletter_emailing');

        if (!emailingRoute) return;

        replace(`/${emailingRoute.url}`);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    return (
        <>
            <ListingExport selectedItems={checkedRows} entity={CONTACT}/>
            <li className="listing-header__action dropdown"
                onClickCapture={handleNoSelectedItems}>
                <PolIcon icon="actions" className="action__picto"/>
                <ul className="listing-header__action__dropdown">
                    <li className={`listing-header__action__item${(checkedRows?.length === 0 || isLoading) ? ' listing-header__action__item__disabled' : ''}`}
                        onClick={handleMailing}>
                        <p>{t('send_emailing')}</p>
                        {isLoading && <PolIcon icon="circle-notch" className="spinner"/>}
                    </li>
                    {
                        canCreateCampaign() && (
                            <>
                                <li className={`listing-header__action__item${checkedRows.length > 0 ? '' : ' listing-header__action__item__disabled'}`}
                                    onClick={toggleShowCampaignPopup}>
                                    <p>{t("send_campaign")}</p>
                                </li>
                                <PolPopup isOpen={showCampaignPopup}
                                          closePopup={toggleShowCampaignPopup}
                                          title={t('create_campaign')}>
                                    <CampaignPopup selectedIds={checkedRows}
                                                   toggleShow={toggleShowCampaignPopup}/>
                                </PolPopup>
                            </>
                        )
                    }
                    <SearchLinkedEntitiesList entity={CONTACT} checkedRows={checkedRows}/>
                </ul>
            </li>
        </>
    )
}
